import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { SettingsState, SettingsStore } from './settings.store';

@Injectable({
  providedIn: 'root',
})
export class SettingsQuery extends Query<SettingsState> {
  showOperation$ = this.select((state) => state.showOperation);
  showBarcodeScanner$ = this.select((state) => state.showBarcodeScanner);
  showTimeInEdit$ = this.select((state) => state.showTimeInEdit);
  preferredDayInfoViewState$ = this.select(
    (state) => state.preferredDayInfoViewState
  );
  preferredExpenseViewState$ = this.select(
    (state) => state.preferredExpenseViewState
  );
  preferredBookingViewState$ = this.select(
    (state) => state.preferredBookingViewState
  );
  showMultiOrder$ = this.select((state) => state.showMultiOrder);
  userLanguage$ = this.select((state) => state.userLanguage);

  constructor(protected store: SettingsStore) {
    super(store);
  }

  getShowTimeInEdit() {
    return this.getValue()?.showTimeInEdit;
  }

  selectDarkMode() {
    return this.select((state) => state.darkMode);
  }

  selectTheme() {
    return this.select((state) => state.theme);
  }
}
